/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessingJobModelDto } from '../../models/processing-job-model-dto';

export interface MatchVideoControllerGetJob$Params {
  uuid: string;
}

export function matchVideoControllerGetJob(http: HttpClient, rootUrl: string, params: MatchVideoControllerGetJob$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerGetJob.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessingJobModelDto>;
    })
  );
}

matchVideoControllerGetJob.PATH = '/match-videos/{uuid}/job';
